import { IPagination } from "./user";

export interface ILedgerHistory {
  createdOn: string;
  name: string;
  remarks: string[];
  userId: string;
  userType: string;
}

export interface ILedgerBrandInfo {
  _id: string;
  logoUrl: string;
  name: string;
  companyName: string;
}

export enum LEDGER_TYPE {
  Debit = "Debit",
  Credit = "Credit",
}

export interface IBriefLedger {
  _id: string;
  brand: ILedgerBrandInfo;
  brandId: string;
  billing: { _id: string; name: string; billingId: string };
  brief: {
    _id: string;
    brandName: string;
    name: string;
    briefId: string;
  };
  billingId: string;
  briefId: string;
  briefInfluencer: string;
  briefInfluencerId: string;
  influencerFullName: string;
  socialMediaName: string;
  type: LEDGER_TYPE;
  subType: string;
  sellingCost: number;
  serviceCost: number;
  gstRateserviceCost: number;
  baseCost: number;
  gstRate: number;
  gstAmount: number;
  totalAmount: number;
  createdBy: string;
  createdByModelName: string;
  createdByType: string;
  updatedBy: string;
  updatedByModelName: string;
  updatedByType: string;
  history: ILedgerHistory[];
  createdAt: string;
  updatedAt: string;
  category?: string;
  __v: number;
  remarks?: string;

  score: number;
}

export interface IGetBriefLedgers {
  data: IBriefLedger[];
  pagination: IPagination;
}

export interface IGetBrandLedgerFacets {
  billing: { name: string; _id: string }[];
  type: { _id: string }[];
  subType: { _id: string }[];
}

export interface ICreateBriefLedger {
  briefId: string;
  remarks: string;
  sellingCost: number;
  serviceCost: number;
  gstRate: number;
  type: LEDGER_TYPE;
  subType: string;
}

export interface IEditBriefLedger {
  ledgerId: string;
  remarks: string;
  sellingCost: number;
  serviceCost: number;
  gstRate: number;
  type: LEDGER_TYPE;
  subType: string;
}
export interface IBriefLedgerSearchRequest {
  briefId: string;
  pageNo?: number;
  limit?: number;
  searchQuery?: string;
  type?: LEDGER_TYPE[];
  subType?: string[];
  billingId?: string[];
}
export interface IBriefLedgersSearchRequest {
  briefIds: string[];
  searchQuery?: string;
}

export interface IGetBriefLedgerAggregation {
  debits: {
    sellingCost: number;
    serviceCost: number;
    baseCost: number;
    gstAmount: number;
    totalAmount: number;
  };
  credits: {
    sellingCost: number;
    serviceCost: number;
    baseCost: number;
    gstAmount: number;
    totalAmount: number;
  };
  all: {
    sellingCost: number;
    serviceCost: number;
    baseCost: number;
    gstAmount: number;
    totalAmount: number;
  };
}
